import { truncateAtNthString } from "./truncateAtNthString"

export function truncateTechnicalUpdate(content) {
    return ` ${truncateAtNthString(content, 3, "</p>")}`
}
